module.exports = __webpack_public_path__ + "img/office.e7219800.svg";